import Vue from 'vue'
import router from '../../router'
import axios from "axios";
import {serverUrl} from "../../config";

export default {
  addDocumentType ({ commit }, name) {
    return Vue.axios.post('/about/documents/types', { name })
    .then(({ data }) => commit('ADD_NEW_DOCUMENT_TYPE', data))
  },
  getDocumentType ({ commit }, id) {
    return Vue.axios.get(`/about/documents/types/${id}`)
    .then(({ data }) => commit('ADD_DOCUMENT_TYPE', data))
  },
  getDocumentsTypes ({ commit }, id) {
    return Vue.axios.get(`/about/documents/types`)
    .then(({ data }) => {
      commit('ADD_DOCUMENTS_TYPES', data)
      if (!id && data[0]) {
        commit('ADD_DOCUMENT_TYPE', data[0])
      }
    })
  },
  getNewDocumentsTypes ({ commit }, id) {
    return axios.get(`${serverUrl}/resource-processing-svc/resources?path=grottsite.dokumenty_dlya_obsluzhivaniya_klientov&fulldepth=true`)
    .then(({ data }) => {
      commit('ADD_NEWDOCUMENTS_TYPES', data)
    })
  },
  deleteDocumentType ({ commit, state }, id) {
    return Vue.axios.delete(`/about/documents/types/${id}`)
    .then(() => {
      commit('DELETE_DOCUMENT_TYPE', id)
      if (state.documentTypes[0]) {
        router.push(`/about/documents/all/${state.documentTypes[0].id}`)
        commit('ADD_DOCUMENT_TYPE', state.documentTypes[0])
      } else {
        router.push(`/about/documents/all`)
      }
    })
  },
  updateDocumentTypes ({ commit }, data) {
    commit('ADD_DOCUMENTS_TYPES', data)
    return Vue.axios.put(`/about/documents/types`, { data })
  },
  addDocument ({ commit }, data) {
    commit('ADD_NEW_DOCUMENT', data)
  },
  deleteDocument ({ commit }, id) {
    commit('DELETE_DOCUMENT', id)
  },
  updateDocument ({ commit }, doc) {
    commit('UPDATE_DOCUMENT', doc)
  },
  saveDocuments ({ commit, dispatch }, documentType) {
    return Vue.axios.put(`/about/documents`, { documentType })
    .then(() => {
      return documentType.documents.filter(d => d.newFile).reduce(
        (p, v) => p.then((a) => v.newFile && dispatch('loadDocumentFile', { formData: v.newFile, id: v.id }).then(r => a.concat([r]))),
        Promise.resolve([])
      )
    })
  },
  updateDocumentsOrder ({ commit }, documents) {
    commit('UPDATE_DOCUMENTS_ORDER', documents)
  },
  loadDocumentFile ({ commit }, { formData, id }) {
    return Vue.axios.post(`/about/documents/${id}/change-file`, formData)
  },
  addLicense ({ commit }, license) {
    commit('ADD_NEW_LICENSE', license)
  },
  addLicensePhoto ({ commit }, license) {
    commit('ADD_LICENSE_PHOTO', license)
  },
  getLicense ({ commit }, id) {
    return Vue.axios.get(`/about/documents/license`)
    .then(({ data }) => commit('ADD_LICENSE', data))
  },
  updateLicense ({ commit }, license) {
    commit('UPDATE_LICENSE', license)
  },
  saveLicense ({ commit, dispatch }, license) {
    let newPhoto
    if (license.photo && typeof license.photo === 'object') {
      newPhoto = license.photo.data
      license.photo = '-'
    }
    return Vue.axios.put(`/about/documents/license`, { license })
    .then(() => {
      if (newPhoto) {
        return dispatch('loadLicensePhoto', { formData: newPhoto, id: license.id })
      }
    })
  },
  loadLicensePhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`/about/documents/license/${id}/change-photo`, formData)
  },
  deleteLicense ({ commit }, id) {
    return Vue.axios.delete(`/about/documents/license/${id}`)
    .then(() => commit('DELETE_LICENSE', id))
  },
  deleteLicensePhoto ({ commit }, id) {
    setTimeout(() => { commit('DELETE_LICENSE_PHOTO', id) }, 0)
  },
  getFinancialDocuments ({ commit }, id) {
    return Vue.axios.get(`/about/documents/financial-documents`)
    .then(({ data }) => commit('ADD_FINANCIAL_DOCUMENTS', data))
  },
  addFinancialDocument ({ commit }, data) {
    commit('ADD_NEW_FINANCIAL_DOCUMENT', data)
  },
  deleteFinancialDocument ({ commit }, id) {
    commit('DELETE_FINANCIAL_DOCUMENT', id)
  },
  updateFinancialDocument ({ commit }, document) {
    commit('UPDATE_FINANCIAL_DOCUMENT', document)
  },
  saveFinancialDocuments ({ commit, dispatch }, documents) {
    return Vue.axios.put(`/about/documents/financial-documents`, { documents })
    .then(() => {
      return documents.filter(d => d.newFile).reduce(
        (p, v) => p.then((a) => dispatch('loadFinancialDocumentFile', { formData: v.newFile, id: v.id }).then(r => a.concat([r]))),
        Promise.resolve([])
      )
    })
  },
  loadFinancialDocumentFile ({ commit }, { formData, id }) {
    return Vue.axios.post(`/about/documents/financial-documents/${id}/change-file`, formData)
  },
  updateFinancialDocuments ({ commit }, documents) {
    commit('ADD_FINANCIAL_DOCUMENTS', documents)
  },
  getDeponentsData ({ commit }, id) {
    return Vue.axios.get(`/about/documents/deponents-data`)
    .then(({ data }) => commit('ADD_DEPONENTS_DATA', data))
  },
  addDeponentsData ({ commit }, id) {
    return Vue.axios.post(`/about/documents/deponents-data`)
    .then(({ data }) => commit('ADD_NEW_DEPONENTS_DATA', data))
  },
  updateDeponentsData ({ commit }, data) {
    return Vue.axios.put(`/about/documents/deponents-data`, { data })
  },
  deleteDeponentsData ({ commit }, id) {
    return Vue.axios.delete(`/about/documents/deponents-data/${id}`)
    .then(() => commit('DELETE_DEPONENTS_DATA', id))
  },
  loadDeponentsDocumentFile ({ commit }, { formData, id }) {
    return Vue.axios.post(`/about/documents/deponents-data/${id}/change-file`, formData)
    .then(({ data }) => commit('CHANGE_DEPONENTS_DOCUMENT_FILE', data))
  },
  deleteDeponentsDocumentFile ({ commit }, id) {
    return Vue.axios.delete(`/about/documents/deponents-data/${id}/change-file`)
    .then(({ data }) => commit('CHANGE_DEPONENTS_DOCUMENT_FILE', data))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/documents.js